// An emoji drawn on a canvas with its visible pixels centred (map/draw.ts paintEmojiGlyph): text layout can't be
// trusted to centre small emoji (Chrome on a 2x screen draws them a fifth smaller, pinned left).
import { useLayoutEffect, useRef } from "react";
import { paintEmojiGlyph } from "../map/draw";

export function EmojiGlyph({ emoji, px }: { emoji: string; px: number }) {
  const ref = useRef<HTMLCanvasElement>(null);
  useLayoutEffect(() => { if (ref.current) paintEmojiGlyph(ref.current, emoji, px); }, [emoji, px]);
  return <canvas ref={ref} className="emoji-glyph" data-emoji={emoji} style={{ display: "block", flex: "none" }} />;
}
